import { render, staticRenderFns } from "./FooterNovalisCircle.vue?vue&type=template&id=58096481&"
import script from "./FooterNovalisCircle.vue?vue&type=script&lang=js&"
export * from "./FooterNovalisCircle.vue?vue&type=script&lang=js&"
import style0 from "./FooterNovalisCircle.vue?vue&type=style&index=0&id=58096481&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports